function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "interface",
  transform: "translate(0.000000, 2.000000)"
}, React.createElement("circle", {
  id: "Ellipse_12",
  fill: "#666666",
  fillRule: "nonzero",
  cx: 12.0050323,
  cy: 14.9643871,
  r: 1
}), React.createElement("rect", {
  id: "Rectangle_12",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 0.342580645,
  y: 0.342580645,
  width: 23.3249032,
  height: 16.7496774,
  rx: 3.645
}), React.createElement("polygon", {
  id: "Path_254",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "15.0011613 20.5869677 9.00890323 20.5869677 9.64722581 17.1367742 14.3643871 17.1367742"
}), React.createElement("line", {
  x1: 7.98387097,
  y1: 20.5869677,
  x2: 16.0258065,
  y2: 20.5869677,
  id: "Line_27",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 0.342580645,
  y1: 12.9870968,
  x2: 23.6674839,
  y2: 12.9870968,
  id: "Line_28",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("circle", {
  id: "Ellipse_13",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 8.54593548,
  cy: 5.72167742,
  r: 1
}), React.createElement("polygon", {
  id: "Path_255",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "15.7420645 10.9792258 12.1869677 6.05535484 9.73122581 9.10064516 8.15264516 7.97806452 5.64309677 10.9776774"
}), React.createElement("rect", {
  id: "Rectangle_13",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 2.31909677,
  y: 2.31909677,
  width: 1.64167742,
  height: 6.432
}), React.createElement("rect", {
  id: "Rectangle_14",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 17.7023226,
  y: 2.31909677,
  width: 3.98864516,
  height: 8.64232258
}), React.createElement("line", {
  x1: 4.12529032,
  y1: 2.31909677,
  x2: 17.7023226,
  y2: 2.31909677,
  id: "Line_29",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 5.8796129,
  y1: 2.34812903,
  x2: 5.8796129,
  y2: 3.16567742,
  id: "Line_30",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 7.53483871,
  y1: 2.34812903,
  x2: 7.53483871,
  y2: 3.16567742,
  id: "Line_31",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 9.19006452,
  y1: 2.34812903,
  x2: 9.19006452,
  y2: 3.16567742,
  id: "Line_32",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 10.8452903,
  y1: 2.34812903,
  x2: 10.8452903,
  y2: 3.16567742,
  id: "Line_33",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 12.5005161,
  y1: 2.34812903,
  x2: 12.5005161,
  y2: 3.16567742,
  id: "Line_34",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 14.1557419,
  y1: 2.34812903,
  x2: 14.1557419,
  y2: 3.16567742,
  id: "Line_35",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 15.8109677,
  y1: 2.34812903,
  x2: 15.8109677,
  y2: 3.16567742,
  id: "Line_36",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 19.1864516,
  y1: 3.82916129,
  x2: 20.2064516,
  y2: 3.82916129,
  id: "Line_37",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 19.1864516,
  y1: 4.96567742,
  x2: 20.2064516,
  y2: 4.96567742,
  id: "Line_38",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 19.1864516,
  y1: 6.10180645,
  x2: 20.2064516,
  y2: 6.10180645,
  id: "Line_39",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 19.1864516,
  y1: 7.23832258,
  x2: 20.2064516,
  y2: 7.23832258,
  id: "Line_40",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 9.99251613,
  y1: 8.77625806,
  x2: 9.25587097,
  y2: 9.70877419,
  id: "Line_41",
  stroke: "#666666",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

function SvgUi(props) {
  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,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";
export { SvgUi as ReactComponent };